// The pure helpers (toSlug, SITE_URL, Amazon URL/tag logic, stripCitations)
// moved to packages/plample-core so the Reddit outreach tool can share them.
// cn() stays here: it exists for Tailwind class merging, which is a concern of
// this app's components, not of the DOM-free core package.
export * from "plample-core/utils";

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
